query DistributionLayoutTypes{
  distributionLayoutTypes( 
    filter: {description: {isNull: false}}
    orderBy: SORT_ORDER_ASC) {
    nodes {
      id
      description
      layoutType
    }
  }
}
